export const PRODUCT_NAME = 'hotels'
export const HOTEL = 'hotel'
export const ACCOMMODATION = 'accommodation'
